module.exports = __webpack_public_path__ + "fonts/400-italic-latin-ext.9a3fc39.woff2";